<!-----------------------------------------------------------------------------
  Copyright (c) 2016 - 2024.                                                  -
  Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)           -
  All Rights Reserved.                                                        -
                                                                              -
  The software and data contained herein are confidential and proprietary     -
  information of Yega Yazilim ("Confidential Information").                   -
                                                                              -
  Users of this software may not disclose such Confidential Information and   -
  shall use it only in accordance with the terms of the license agreement     -
  they entered into with Yega Yazilim.                                        -
                                                                              -
  Author:  Ahmet Dogramaci                                                    -
  Date:    2024-08-23                                                         -
  ----------------------------------------------------------------------------->

<template>
  <b-container>
    <b-row class="mb-3">
      <b-col>
        <div class="d-flex justify-content-between">
          <b-button variant="primary" v-on:click="selectCategory(currentCategory.parent_category_id)" v-if="!!currentCategory.parent_category_id">
            <b-icon-chevron-double-left class="mr-1"></b-icon-chevron-double-left>
            {{parentCategory.name}}
          </b-button>
          <p>&nbsp;</p>
        </div>
      </b-col>
      <b-col>
        <div class="d-flex justify-content-end">
          <b-button variant="primary" v-on:click="goToQuote()">
            <b-icon-file-earmark class="mr-1"></b-icon-file-earmark>
            Go To Quote
          </b-button>
          <p>&nbsp;</p>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-button block variant="secondary" size="lg" class="mb-3">
          <h2>{{currentCategory.name}}</h2>
        </b-button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import {BIconChevronDoubleLeft, BIconListCheck, BIconFileEarmark} from "bootstrap-vue";

export default {
  name: "product-category-header",
  components: {BIconChevronDoubleLeft,BIconListCheck, BIconFileEarmark},
  props:{
    currentCategory:{
      type: Object,
      required: true
    },
    parentCategory:{
      type: Object
    },
  },
  methods:{
    selectCategory(category_id){
      this.$emit('category-selected',category_id);
    },
    goToQuote(){
      this.$router.push({name: 'quote_path'});
    }
  }
}
</script>

<style scoped>

</style>
